(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5650],{

/***/ 36906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/pages/sitemap/influencers/index.module.less
var index_module = __webpack_require__(20915);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Menu/index.js + 11 modules
var Menu = __webpack_require__(28096);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Layout/index.js + 3 modules
var Layout = __webpack_require__(64606);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Breadcrumb/index.js + 2 modules
var Breadcrumb = __webpack_require__(97607);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/List/index.js + 3 modules
var List = __webpack_require__(36097);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Pagination/index.js + 4 modules
var Pagination = __webpack_require__(90652);
// EXTERNAL MODULE: ./src/utils/useLocale.ts
var useLocale = __webpack_require__(83126);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
// EXTERNAL MODULE: ./src/hooks/useRegionOptions.ts
var useRegionOptions = __webpack_require__(3770);
// EXTERNAL MODULE: ./src/api/influencer.ts
var influencer = __webpack_require__(82356);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useSetState/index.js
var useSetState = __webpack_require__(96638);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useUpdateEffect/index.js
var useUpdateEffect = __webpack_require__(42170);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/pages/sitemap/products/index.tsx
var products = __webpack_require__(18491);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/sitemap/influencers/index.tsx














const MenuItem = Menu/* default.Item */.Z.Item;
const Sider = Layout/* default.Sider */.Z.Sider;
const Header = Layout/* default.Header */.Z.Header;
const Content = Layout/* default.Content */.Z.Content;
const DYNAMIC_INFLUENCERS_CATEGORY = `hot-{category}-influencers-in-{regionName}-on-tiktok`;
const REGEX = /hot-(.+?)-influencers-in-(.+?)-on-tiktok/;
const getCategoryString = function () {
  let currentCategoryNameSlug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let currentRegionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return DYNAMIC_INFLUENCERS_CATEGORY.replace('{category}', currentCategoryNameSlug || '').replace('{regionName}', currentRegionName);
};
const getUrlField = str => {
  const match = str.match(REGEX);

  if (match) {
    const urlCategoryNameSlug = match[1];
    const urlRegion = match[2];
    return {
      urlCategoryNameSlug: urlCategoryNameSlug,
      urlRegion: urlRegion
    };
  } else {
    return {};
  }
};
const useFooterLinks = _ref => {
  let {
    category,
    region
  } = _ref;
  const t = (0,useLocale/* default */.Z)();
  const curCategory = category.toLowerCase() === 'all' ? '' : category;
  return [{
    name: t['seo.sitemap.influencers.tag1'].replace('{category}', curCategory || '').replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.influencers.tag2'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.influencers.tag3'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.influencers.tag4'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.influencers.tag5'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.influencers.tag6'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }];
};
const InfluencerItem = _ref2 => {
  let {
    item
  } = _ref2;
  const t = (0,useLocale/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default()).listItem,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: `/influencers/${item.influencer_id}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (index_module_default()).mb6,
          style: {
            fontWeight: 700,
            color: 'rgb(64, 61, 90)',
            wordBreak: 'break-all'
          },
          children: item.influencer_name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).mb6,
          style: {
            wordBreak: 'break-all'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            style: {
              fontWeight: 400,
              color: '#898e99'
            },
            children: ["@", item.unique_id]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (index_module_default()).ml10,
            children: [t['common.region'], ": ", item.region.name]
          })]
        }), item.bio && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            wordBreak: 'break-all'
          },
          children: ["BIO: ", item.bio]
        })]
      })
    })
  });
};
const useBreadcrumbs = _ref3 => {
  let {
    currentCategoryObj,
    currentRegionObj
  } = _ref3;
  const t = (0,useLocale/* default */.Z)();
  return [{
    name: t['menu.platform.home'],
    href: '/'
  }, {
    name: t['seo.sitemap.influencer_breadcrumb'],
    href: '/influencers'
  }, {
    name: currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name,
    href: `/sitemap/influencers/${getCategoryString(currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug)}/1`
  }, {
    name: currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name,
    href: ''
  }];
};

const InfluencerSitemap = _ref4 => {
  var _influencer_categorie, _dataFromSSR$meta, _dataFromSSR$meta2;

  let {
    filtersFromSSR,
    dataFromSSR
  } = _ref4;
  const {
    influencer_categories
  } = filtersFromSSR || {};
  const t = (0,useLocale/* default */.Z)();
  const {
    0: activeCategoryKey,
    1: setActiveCategoryKey
  } = (0,react.useState)(((_influencer_categorie = influencer_categories[0]) === null || _influencer_categorie === void 0 ? void 0 : _influencer_categorie.key) || 'All');
  const {
    0: dataList,
    1: setDataList
  } = (0,react.useState)((dataFromSSR === null || dataFromSSR === void 0 ? void 0 : dataFromSSR.data) || []);
  const router = (0,next_router.useRouter)();
  const {
    0: loading,
    1: setLoading
  } = (0,react.useState)(false);
  const {
    region
  } = (0,es/* useSelector */.v9)(state => state.ssr);
  const {
    regionOptions
  } = (0,useRegionOptions/* default */.Z)();
  const [pageObj, setPageObj] = (0,useSetState/* default */.Z)({
    total: ((_dataFromSSR$meta = dataFromSSR.meta) === null || _dataFromSSR$meta === void 0 ? void 0 : _dataFromSSR$meta.total) || 0,
    pageSize: ((_dataFromSSR$meta2 = dataFromSSR.meta) === null || _dataFromSSR$meta2 === void 0 ? void 0 : _dataFromSSR$meta2.per_page) || 200
  });
  const originRegionObj = regionOptions.find(r => r.region === region);
  const currentUrlCategory = router.query.influencers_category;
  const currentUrlPage = router.query.page || '1';
  const currentCategoryObj = influencer_categories.find(c => c.key === activeCategoryKey);
  const currentCategoryNameSlug = currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug;
  const {
    0: currentRegionObj,
    1: setCurrentRegionObj
  } = (0,react.useState)(originRegionObj);
  const breadcrumbs = useBreadcrumbs({
    currentRegionObj,
    currentCategoryObj
  });
  const {
    urlCategoryNameSlug,
    urlRegion
  } = getUrlField(currentUrlCategory);
  (0,react.useLayoutEffect)(() => {
    if (urlCategoryNameSlug && urlRegion) {
      var _influencer_categorie2;

      const curActiveCategoryKey = (_influencer_categorie2 = influencer_categories.find(c => c.name_slug === urlCategoryNameSlug)) === null || _influencer_categorie2 === void 0 ? void 0 : _influencer_categorie2.key;
      curActiveCategoryKey && setActiveCategoryKey(curActiveCategoryKey);
      const curReginObj = regionOptions.find(r => r.nameSlug === urlRegion);
      curReginObj && setCurrentRegionObj(curReginObj);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const fetchList = (0,react.useCallback)(async params => {
    setLoading(true);
    (0,influencer/* getInfluencersSitemapApi */.ac)(params).then(res => {
      if (res.data.code === constants/* SUCCESS_CODE */.Gh) {
        var _res$data$meta, _res$data$meta2;

        setDataList(res.data.data || []);
        setPageObj({
          total: (_res$data$meta = res.data.meta) === null || _res$data$meta === void 0 ? void 0 : _res$data$meta.total,
          pageSize: (_res$data$meta2 = res.data.meta) === null || _res$data$meta2 === void 0 ? void 0 : _res$data$meta2.per_page
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [setPageObj]);
  (0,useUpdateEffect/* default */.Z)(() => {
    var _influencer_categorie3;

    fetchList({
      influencer_categories: ((_influencer_categorie3 = influencer_categories.find(c => c.key === activeCategoryKey)) === null || _influencer_categorie3 === void 0 ? void 0 : _influencer_categorie3.id) || '',
      page: currentUrlPage,
      region: currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region
    });
  }, [activeCategoryKey, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region, currentUrlPage, fetchList, influencer_categories]);

  const handleReginClick = item => {
    setCurrentRegionObj(item);
    router.replace({
      pathname: router.basePath,
      query: {
        influencers_category: getCategoryString(currentCategoryNameSlug, item.nameSlug),
        page: '1'
      }
    }, undefined, {
      scroll: false,
      shallow: true
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default()).influencersSitemap,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
      className: "layout-collapse-demo",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Sider, {
        breakpoint: "xl",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "logo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, {
          selectedKeys: [activeCategoryKey],
          onClickMenuItem: key => {
            setActiveCategoryKey(key);
          },
          className: (index_module_default()).menuWrap,
          style: {
            width: '100%'
          },
          children: influencer_categories.map(item => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: {
                  pathname: router.pathname,
                  query: {
                    influencers_category: getCategoryString(item.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                    page: '1'
                  }
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  children: item.name
                })
              })
            }, item.key);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
          style: {
            paddingLeft: 20
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: t['seo.sitemap.influencer_h1'].replace('{category}', (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '').replace('{regionName}', (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || region)
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
          style: {
            padding: '0 24px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
            style: {
              margin: '16px 0'
            },
            children: breadcrumbs.map((item, index) => {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                href: item.href,
                children: item.name
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(products/* RegionList */.YX, {
              onClick: handleReginClick,
              currentCategoryNameSlug: currentCategoryNameSlug,
              currentRegionObj: currentRegionObj,
              categoryKey: "influencers_category"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(List/* default */.Z, {
              loading: loading,
              className: (index_module_default()).listWrap,
              style: {
                marginBottom: '20px'
              },
              children: [dataList.map((item, index) => {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(InfluencerItem, {
                  item: item
                }, index);
              }), !loading && dataList.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  display: 'flex',
                  justifyContent: 'end'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                  className: (index_module_default()).pageWrap,
                  total: pageObj.total,
                  pageSize: pageObj.pageSize,
                  current: currentUrlPage ? +currentUrlPage : 1,
                  itemRender: (page, type, originElement) => {
                    if (type === 'page') {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        href: {
                          pathname: router.pathname,
                          query: {
                            influencers_category: getCategoryString(currentCategoryNameSlug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                            page: `${page}`
                          }
                        },
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          children: page
                        })
                      });
                    }

                    return originElement;
                  }
                })
              }) : null]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(products/* FooterLinks */.qo, {
              category: (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '',
              region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || '',
              useFooterLinks: useFooterLinks
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var influencers = (InfluencerSitemap);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/spin-loading/index.js + 2 modules
var spin_loading = __webpack_require__(87492);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/components/side-bar/index.js + 2 modules
var side_bar = __webpack_require__(25314);
// EXTERNAL MODULE: ./src/mobile-pages/sitemap/influencers/index.module.less
var influencers_index_module = __webpack_require__(67442);
var influencers_index_module_default = /*#__PURE__*/__webpack_require__.n(influencers_index_module);
// EXTERNAL MODULE: ./src/store/index.ts
var store = __webpack_require__(26638);
// EXTERNAL MODULE: ./src/api/request.ts
var request = __webpack_require__(84425);
// EXTERNAL MODULE: ./src/utils/getServerSidePropsCatch.ts
var getServerSidePropsCatch = __webpack_require__(17648);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/mobile-pages/sitemap/influencers/index.tsx





















const InfluencersSitemap = _ref => {
  var _dataFromSSR$meta, _dataFromSSR$meta2;

  let {
    filtersFromSSR,
    dataFromSSR
  } = _ref;
  const {
    influencer_categories
  } = filtersFromSSR || {};
  const t = (0,useLocale/* default */.Z)();
  const {
    0: activeCategoryId,
    1: setActiveCategoryId
  } = (0,react.useState)('');
  const {
    0: dataList,
    1: setDataList
  } = (0,react.useState)((dataFromSSR === null || dataFromSSR === void 0 ? void 0 : dataFromSSR.data) || []);
  const router = (0,next_router.useRouter)();
  const {
    0: loading,
    1: setLoading
  } = (0,react.useState)(false);
  const {
    region
  } = (0,es/* useSelector */.v9)(state => state.ssr);
  const {
    regionOptions
  } = (0,useRegionOptions/* default */.Z)();
  const [pageObj, setPageObj] = (0,useSetState/* default */.Z)({
    total: ((_dataFromSSR$meta = dataFromSSR.meta) === null || _dataFromSSR$meta === void 0 ? void 0 : _dataFromSSR$meta.total) || 0,
    pageSize: ((_dataFromSSR$meta2 = dataFromSSR.meta) === null || _dataFromSSR$meta2 === void 0 ? void 0 : _dataFromSSR$meta2.per_page) || 200
  });
  const originRegionObj = regionOptions.find(r => r.region === region);
  const currentUrlCategory = router.query.influencers_category;
  const currentUrlPage = router.query.page || '1';
  const currentCategoryObj = influencer_categories.find(c => c.id === activeCategoryId);
  const currentCategoryNameSlug = currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug;
  const {
    0: currentRegionObj,
    1: setCurrentRegionObj
  } = (0,react.useState)(originRegionObj);
  const {
    urlCategoryNameSlug,
    urlRegion
  } = getUrlField(currentUrlCategory);
  const footerList = useFooterLinks({
    category: (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '',
    region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || ''
  });
  (0,react.useLayoutEffect)(() => {
    if (urlCategoryNameSlug && urlRegion) {
      var _influencer_categorie;

      const curActiveCategoryId = (_influencer_categorie = influencer_categories.find(c => c.name_slug === urlCategoryNameSlug)) === null || _influencer_categorie === void 0 ? void 0 : _influencer_categorie.id;
      curActiveCategoryId && setActiveCategoryId(curActiveCategoryId);
      const curReginObj = regionOptions.find(r => r.nameSlug === urlRegion);
      curReginObj && setCurrentRegionObj(curReginObj);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const breadcrumbs = useBreadcrumbs({
    currentRegionObj,
    currentCategoryObj
  });
  const fetchList = (0,react.useCallback)(async params => {
    setLoading(true);
    (0,influencer/* getInfluencersSitemapApi */.ac)(params).then(res => {
      if (res.data.code === constants/* SUCCESS_CODE */.Gh) {
        var _res$data$meta, _res$data$meta2;

        setDataList(res.data.data || []);
        setPageObj({
          total: (_res$data$meta = res.data.meta) === null || _res$data$meta === void 0 ? void 0 : _res$data$meta.total,
          pageSize: (_res$data$meta2 = res.data.meta) === null || _res$data$meta2 === void 0 ? void 0 : _res$data$meta2.per_page
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [setPageObj]);
  (0,useUpdateEffect/* default */.Z)(() => {
    fetchList({
      influencer_categories: activeCategoryId,
      page: currentUrlPage,
      region: currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region
    });
  }, [activeCategoryId, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region, currentUrlPage, fetchList]);

  const handleReginClick = item => {
    setCurrentRegionObj(item);
    router.replace({
      pathname: router.basePath,
      query: {
        influencers_category: getCategoryString(currentCategoryNameSlug, item.nameSlug),
        page: '1'
      }
    }, undefined, {
      scroll: false,
      shallow: true
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (influencers_index_module_default()).productsSitemap,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
        children: breadcrumbs.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
            href: item.href,
            children: item.name
          }, index);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      style: {
        color: '#0f1219'
      },
      children: t['seo.sitemap.influencer_h1'].replace('{category}', currentCategoryNameSlug || '').replace('{regionName}', (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || region)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (influencers_index_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (influencers_index_module_default()).side,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(side_bar/* default */.Z, {
          activeKey: activeCategoryId,
          onChange: key => {
            setActiveCategoryId(key);
          },
          children: influencer_categories.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(side_bar/* default.Item */.Z.Item, {
            title: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: {
                pathname: router.pathname,
                query: {
                  influencers_category: getCategoryString(item.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                  page: '1'
                }
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: item.name
              })
            })
          }, item.id))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (influencers_index_module_default()).main,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (influencers_index_module_default()).regionWrap,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (influencers_index_module_default()).regionLabel,
            children: t['common.region']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (influencers_index_module_default()).regionList,
            children: regionOptions.map(option => {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: classnames_default()((influencers_index_module_default()).regionItem, {
                  [(influencers_index_module_default()).selectedRegion]: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region) === option.region
                }),
                onClick: () => handleReginClick(option),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: {
                    pathname: router.pathname,
                    query: {
                      influencers_category: getCategoryString(currentCategoryNameSlug, option === null || option === void 0 ? void 0 : option.nameSlug),
                      page: '1'
                    }
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    style: {
                      pointerEvents: 'none'
                    },
                    children: option.name
                  })
                })
              }, option.region);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (influencers_index_module_default()).productsSitemapList,
          children: [loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(spin_loading/* default */.Z, {}) : dataList.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(InfluencerItem, {
              item: item
            }, index);
          }), !loading && dataList.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              display: 'flex',
              justifyContent: 'center'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* default */.Z, {
              total: pageObj.total,
              pageSize: pageObj.pageSize,
              current: currentUrlPage ? +currentUrlPage : 1,
              itemRender: (page, type, originElement) => {
                if (type === 'page') {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: {
                      pathname: router.pathname,
                      query: {
                        influencers_category: getCategoryString(currentCategoryNameSlug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                        page: `${page}`
                      }
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      children: page
                    })
                  });
                }

                return originElement;
              }
            })
          }) : null]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: footerList.map(item => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          color: "primary",
          className: (influencers_index_module_default()).tagSpan,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: item.href,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: item.name
            })
          })
        }, item.name);
      })
    })]
  });
};

const getServerSideProps = store/* wrapper.getServerSideProps */.YS.getServerSideProps(store => async context => {
  try {
    const ssrCtx = (0,request/* generateSsrCtx */._8)(store.getState());
    const [filters] = await Promise.all([(0,influencer/* getInfluencerFilterApi */.IX)({
      ssrCtx
    }).then(request/* backendCodeProcessor */.KA)]);
    const data = await (0,influencer/* getInfluencersSitemapApi */.ac)({
      influencer_categories: '',
      page: context.query.page || '1'
    }, {
      ssrCtx
    }).then(res => {
      if (res.data.code === constants/* SUCCESS_CODE */.Gh) {
        return res.data;
      }
    });
    return {
      props: {
        filtersFromSSR: filters,
        dataFromSSR: data
      }
    };
  } catch (error) {
    return (0,getServerSidePropsCatch/* default */.Z)(error);
  }
});
/* harmony default export */ var sitemap_influencers = (InfluencersSitemap);
// EXTERNAL MODULE: ./src/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(97588);
;// CONCATENATED MODULE: ./pages/sitemap/influencers/[influencers_category]/[page].tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const Influencers = props => {
  return (0,useIsMobile/* default */.Z)() ? /*#__PURE__*/(0,jsx_runtime.jsx)(sitemap_influencers, _objectSpread({}, props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(influencers, _objectSpread({}, props));
};

var __N_SSP = true;
/* harmony default export */ var _page_ = (Influencers);

/***/ }),

/***/ 82356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* binding */ getBatchInfluencerApi; },
/* harmony export */   "I7": function() { return /* binding */ getInfluencerProductAnalysisApi; },
/* harmony export */   "IX": function() { return /* binding */ getInfluencerFilterApi; },
/* harmony export */   "LS": function() { return /* binding */ getInfluencerDetailFilterApi; },
/* harmony export */   "ac": function() { return /* binding */ getInfluencersSitemapApi; },
/* harmony export */   "zA": function() { return /* binding */ getInfluencerListApi; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84425);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const getInfluencerListApi = (params, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/influencers`, _objectSpread({
    params
  }, config));
};
const getInfluencerFilterApi = config => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/influencers/filters`, config);
}; // 获取达人

const getInfluencersSitemapApi = async (params, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/influencers/sitemap/list`, _objectSpread({
    params
  }, config));
};
const getBatchInfluencerApi = (data, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post(`/data/influencers/batches`, _objectSpread(_objectSpread({}, data), config));
};
const getInfluencerDetailFilterApi = (id, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/influencers/${id}/products/filters`, config);
};
const getInfluencerProductAnalysisApi = (id, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/influencers/${id}/products/analysis`, config);
};

/***/ }),

/***/ 52619:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/influencers/[influencers_category]/[page]",
      function () {
        return __webpack_require__(36906);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productsSitemap":"index_productsSitemap__7dBKa","productsSitemapList":"index_productsSitemapList__rV57K","listItem":"index_listItem__8z2xF","container":"index_container__qltlR","side":"index_side__ZRd0Q","main":"index_main__S7D9i","content":"index_content__BTfyQ","active":"index_active__BhEDq","regionList":"index_regionList__mpGeT","regionItem":"index_regionItem__olTO8","regionWrap":"index_regionWrap__BabsJ","regionLabel":"index_regionLabel__agZin","selectedRegion":"index_selectedRegion__jr4dQ","tagSpan":"index_tagSpan__Qu50j"};

/***/ }),

/***/ 20915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"influencersSitemap":"index_influencersSitemap__r8iez","listItem":"index_listItem__t4qVi","sectionCard":"index_sectionCard__RYqey","listWrap":"index_listWrap__naJkT","mb6":"index_mb6__RMiFE","ml10":"index_ml10__8g_2o","menuWrap":"index_menuWrap__3vBvu","pageWrap":"index_pageWrap__ClOGm"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8096,652,9839,5687,3220,455,8940,3954,4730,9612,7530,4367,9669,4607,8097,8126,6864,1723,641,7716,6337,9195,1349,1771,5434,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,7401,7971,3457,1738,6859,9161,6158,4071,3066], function() { return __webpack_exec__(52619); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);